import type { ReactNode } from 'react'
import { clsx } from 'clsx'

// Pill chip — filters + tags. Accent outline when active. Interactive chips
// (with onClick) meet the 48px touch target; display-only chips (on cards)
// stay compact.
export function Chip({
  children,
  active,
  onClick,
  className,
}: {
  children: ReactNode
  active?: boolean
  onClick?: (() => void) | undefined
  className?: string
}) {
  const Tag = onClick ? 'button' : 'span'
  return (
    <Tag
      onClick={onClick}
      aria-pressed={onClick ? !!active : undefined}
      className={clsx(
        // shrink-0: chips in a scrollable filter row must overflow (scroll), never
        // compress into each other when the row is narrower than its content.
        'inline-flex shrink-0 items-center justify-center gap-1.5 px-3 rounded-full text-[length:var(--fs-sm)] font-semibold whitespace-nowrap',
        onClick ? 'min-h-[var(--tap)] min-w-[var(--tap)]' : 'h-8',
        active
          ? 'border border-[var(--accent)] text-[color:var(--accent)] bg-[var(--accent-wash)]'
          : 'border border-[var(--line)] text-[color:var(--fg-muted)]',
        className,
      )}
    >
      {children}
    </Tag>
  )
}
